// extracted by mini-css-extract-plugin
export default {"disableScroll":"useDisableBodyScroll_disableScroll__1iBpA"};